// UI strings used across all sites (bilingual).
export const T = {
  fr: {
    apply: "Faire une demande",
    seeHow: "Voir comment",
    languageFr: "FR",
    languageEn: "EN",
    languageSwitchLabel: "Langue",
    approvedNote: "Approbation sujette à vérification. Certaines conditions s'appliquent.",
    footerRights: "Tous droits réservés.",
    footerLegal: "Ce site est exploité par un intermédiaire de financement automobile au Québec. Le financement est offert sur crédit approuvé.",
    privacy: "Politique de confidentialité",
    terms: "Conditions d'utilisation",
    contact: "Contact",
    heroCtaSecondary: "En savoir plus",
    scoreHot: "Chaud",
    scoreWarm: "Tiède",
    scoreCold: "Froid",
    form: {
      step: "Étape",
      of: "sur",
      next: "Suivant",
      prev: "Précédent",
      submit: "Soumettre ma demande",
      submitting: "Envoi en cours...",
      successTitle: "Demande reçue !",
      successMessage: "Un conseiller vous contactera sous peu. Vous recevrez aussi une confirmation par courriel.",
      // Step 1
      s1Title: "Quel type de véhicule cherchez-vous ?",
      s1Sub: "Aidez-nous à personnaliser votre approbation.",
      vehicleLabel: "Type de véhicule",
      vehicleOptions: [
        { v: "SUV", l: "VUS" },
        { v: "Sedan", l: "Berline" },
        { v: "Truck", l: "Camion" },
        { v: "Van", l: "Fourgonnette" },
        { v: "NotSure", l: "Pas certain" },
      ],
      budgetLabel: "Budget estimé (mensuel)",
      budgetPh: "Ex : 400",
      downLabel: "Mise de fonds disponible",
      downPh: "Ex : 1500",
      tradeLabel: "Avez-vous un véhicule à échanger ?",
      yes: "Oui",
      no: "Non",
      // Step 2
      s2Title: "Votre situation de crédit",
      s2Sub: "Aucune situation n'est disqualifiante. Soyez honnête, c'est ce qui nous aide.",
      creditOptions: [
        { v: "good", l: "Bon crédit" },
        { v: "bad", l: "Mauvais crédit" },
        { v: "none", l: "Pas de crédit" },
        { v: "bankruptcy", l: "Faillite" },
        { v: "consumer_proposal", l: "Proposition de consommateur" },
        { v: "newcomer", l: "Nouveau au Canada" },
        { v: "not_sure", l: "Je ne sais pas" },
      ],
      // Step 3
      s3Title: "Votre situation d'emploi",
      s3Sub: "C'est le facteur #1 pour l'approbation.",
      empStatusLabel: "Statut d'emploi",
      empOptions: [
        { v: "full_time", l: "Temps plein" },
        { v: "part_time", l: "Temps partiel" },
        { v: "self_employed", l: "Travailleur autonome" },
        { v: "business_owner", l: "Propriétaire d'entreprise" },
        { v: "gig", l: "Gig / plateforme (Uber, etc.)" },
        { v: "contract", l: "Contractuel" },
        { v: "student", l: "Étudiant" },
        { v: "other", l: "Autre" },
      ],
      incomeLabel: "Revenu mensuel net",
      incomePh: "Ex : 3200",
      tenureLabel: "Ancienneté au poste",
      tenureOptions: [
        { v: "0-6", l: "Moins de 6 mois" },
        { v: "6-12", l: "6 à 12 mois" },
        { v: "1-3", l: "1 à 3 ans" },
        { v: "3+", l: "Plus de 3 ans" },
      ],
      residencyLabel: "Statut au Canada",
      residencyOptions: [
        { v: "citizen", l: "Citoyen canadien" },
        { v: "pr", l: "Résident permanent" },
        { v: "work_permit", l: "Permis de travail" },
        { v: "study_permit", l: "Permis d'études" },
        { v: "other", l: "Autre" },
      ],
      // Step 4
      s4Title: "Vos coordonnées",
      s4Sub: "Nous vous contactons dès que votre dossier est prêt.",
      firstName: "Prénom",
      lastName: "Nom",
      phone: "Téléphone",
      email: "Courriel",
      city: "Ville",
      language: "Langue préférée",
      consent:
        "J'autorise à être contacté(e) et à faire vérifier mon dossier de crédit dans le cadre de ma demande de financement. Certaines conditions s'appliquent.",
      required: "Requis",
      invalidEmail: "Courriel invalide",
    },
  },
  en: {
    apply: "Apply now",
    seeHow: "See how",
    languageFr: "FR",
    languageEn: "EN",
    languageSwitchLabel: "Language",
    approvedNote: "Approval is subject to verification. Certain conditions apply.",
    footerRights: "All rights reserved.",
    footerLegal: "This site is operated by a Quebec auto financing intermediary. Financing available on approved credit.",
    privacy: "Privacy policy",
    terms: "Terms of use",
    contact: "Contact",
    heroCtaSecondary: "Learn more",
    scoreHot: "Hot",
    scoreWarm: "Warm",
    scoreCold: "Cold",
    form: {
      step: "Step",
      of: "of",
      next: "Next",
      prev: "Back",
      submit: "Submit my application",
      submitting: "Submitting...",
      successTitle: "Application received!",
      successMessage: "An advisor will contact you shortly. You'll also receive an email confirmation.",
      s1Title: "What kind of vehicle are you looking for?",
      s1Sub: "Help us tailor your approval.",
      vehicleLabel: "Vehicle type",
      vehicleOptions: [
        { v: "SUV", l: "SUV" },
        { v: "Sedan", l: "Sedan" },
        { v: "Truck", l: "Truck" },
        { v: "Van", l: "Van" },
        { v: "NotSure", l: "Not sure" },
      ],
      budgetLabel: "Estimated monthly budget",
      budgetPh: "e.g. 400",
      downLabel: "Down payment available",
      downPh: "e.g. 1500",
      tradeLabel: "Do you have a vehicle to trade in?",
      yes: "Yes",
      no: "No",
      s2Title: "Your credit situation",
      s2Sub: "No situation is a deal-breaker. Being honest helps us most.",
      creditOptions: [
        { v: "good", l: "Good credit" },
        { v: "bad", l: "Bad credit" },
        { v: "none", l: "No credit" },
        { v: "bankruptcy", l: "Bankruptcy" },
        { v: "consumer_proposal", l: "Consumer proposal" },
        { v: "newcomer", l: "New to Canada" },
        { v: "not_sure", l: "Not sure" },
      ],
      s3Title: "Your employment",
      s3Sub: "This is the #1 approval factor.",
      empStatusLabel: "Employment status",
      empOptions: [
        { v: "full_time", l: "Full-time" },
        { v: "part_time", l: "Part-time" },
        { v: "self_employed", l: "Self-employed" },
        { v: "business_owner", l: "Business owner" },
        { v: "gig", l: "Gig / platform (Uber, etc.)" },
        { v: "contract", l: "Contract" },
        { v: "student", l: "Student" },
        { v: "other", l: "Other" },
      ],
      incomeLabel: "Net monthly income",
      incomePh: "e.g. 3200",
      tenureLabel: "Time at current job",
      tenureOptions: [
        { v: "0-6", l: "Less than 6 months" },
        { v: "6-12", l: "6 to 12 months" },
        { v: "1-3", l: "1 to 3 years" },
        { v: "3+", l: "More than 3 years" },
      ],
      residencyLabel: "Status in Canada",
      residencyOptions: [
        { v: "citizen", l: "Canadian citizen" },
        { v: "pr", l: "Permanent resident" },
        { v: "work_permit", l: "Work permit" },
        { v: "study_permit", l: "Study permit" },
        { v: "other", l: "Other" },
      ],
      s4Title: "Your contact details",
      s4Sub: "We'll reach out as soon as your file is ready.",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone",
      email: "Email",
      city: "City",
      language: "Preferred language",
      consent:
        "I authorize being contacted and my credit file being verified as part of my financing application. Certain conditions apply.",
      required: "Required",
      invalidEmail: "Invalid email",
    },
  },
};
